<nb-form-field>
    <nb-icon icon="{{value}}" nbSuffix pack="far"></nb-icon>
    <input [(ngModel)]="value" fullWidth nbInput type="text">
</nb-form-field>
